const baseURL: string = "https://jjrentalapi.azurewebsites.net/api/";

export default baseURL;
